import React,{useEffect} from 'react'
import { Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getGroupsPublicByActivity } from '../../../actions/activities/groupsActions'
import Loader from '../../../components/design/Loader/Loader'
import { getCommissionByClub } from '../../../actions/settings/commissionsActions'

export default function Description({activity}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.categories)
    const { groupsMarket: groups } = useSelector(state => state.groups)
	const {commission} = useSelector(state=>state.commissions)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if (activity) {
            dispatch(getGroupsPublicByActivity(activity?._id))
            dispatch(getCommissionByClub(activity?.club?._id))
        }
    }, [dispatch, activity])

    const getPrice = (price) => {
        if (price && !isNaN(price)) {
            const activity = commission?.activities?.find(activity => price >= activity.lowPrice && price <= activity.highPrice);
            if (activity) {
                return price > 0 ? (price + (Math.ceil(((price * (activity.percentage || 0) / 100) + (activity.double || 0)) * 100) / 100)).toFixed(2) : parseFloat(price).toFixed(2)
            } else {
                return parseFloat(price).toFixed(2)
            }
        } else {
            return '0.00'
        }
    }

    const calculateTotal = (registrationPayment, seasonPayments) => {
        const seasonTotal = seasonPayments?.reduce((total, payment) => total += payment.price, 0) || 0
        return getPrice((seasonTotal + (registrationPayment?.price || 0)))
    }

    return (
        <>
        {
        loading
        ?
            <Loader/>
        :
            <>
                <div className='section-header'>
                    <div>
                        <h2>{t('global.description')}</h2>
                    </div>
                    <button className='btn-share' title="Compartir">
                        <img src="/images/share.svg" alt="Compartir" width={20} />
                    </button>
                </div>

                <div className='activity-description mb-5' dangerouslySetInnerHTML={{ __html: activity?.description }} />

                <div className='section-header'>
                    <h2>{t('marketplace.activity.details')}</h2>
                </div>

                <div className='groups-list'>
                    {groups?.map((group, index) => (
                        <div key={index} className='group-detail-card'>
                            <div className='group-detail-header'>
                                <div className='group-detail-title'>
                                    <h3>{group?.category?.title}</h3>
                                    <span className='group-detail-age'>
                                        {group?.category?.ageFrom} - {group?.category?.ageTo} {t('marketplace.activity.yearsOld')}
                                    </span>
                                </div>
                                <div className='group-detail-price'>
                                    {calculateTotal(group?.registrationPayment, group?.seasonPayments)}€
                                </div>
                            </div>

                            <div className='group-detail-rows'>
                                <div className='group-detail-row'>
                                    <span className='group-detail-label'>{t('marketplace.activity.category')}</span>
                                    <span className='group-detail-value'>{group?.category?.title} ({group?.category?.ageFrom} - {group?.category?.ageTo} {t('marketplace.activity.yearsOld')})</span>
                                </div>
                                <div className='group-detail-row'>
                                    <span className='group-detail-label'>{t('marketplace.activity.federated')}</span>
                                    <span className='group-detail-value'>
                                        <span className={`group-detail-badge ${group?.federated ? 'active' : ''}`}>
                                            {group?.federated ? t('global.yes') : t('global.no')}
                                        </span>
                                    </span>
                                </div>
                                {group?.registrationPayment &&
                                    <div className='group-detail-row'>
                                        <span className='group-detail-label'>{group?.registrationPayment.title}</span>
                                        <span className='group-detail-value price'>{getPrice(group?.registrationPayment?.price)}€</span>
                                    </div>
                                }
                                {group?.seasonPayments?.length > 0 &&
                                    <>
                                        <div className='group-detail-row'>
                                            <span className='group-detail-label'>{t('marketplace.activity.seasonPayments')}</span>
                                            <span className='group-detail-value'>
                                                {getPrice(group?.seasonPayments?.reduce((total, payment) => total += payment.price, 0))}€
                                                <span className='group-detail-count'>({group?.seasonPayments?.length} {t('marketplace.activity.seasons')})</span>
                                            </span>
                                        </div>
                                        <div className='group-detail-row total'>
                                            <span className='group-detail-label'>{t('marketplace.activity.total')}</span>
                                            <span className='group-detail-value price'>{calculateTotal(group?.registrationPayment, group?.seasonPayments)}€</span>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </>
        }
        </>
    )
}
